if (!customElements.get('section-community-clubs-with-map')) {

    class SectionCommunityClubsWithMap extends HTMLElement {

        constructor() {
            super();

            this.mapLoaded = false;
            this._isOpened = false;
            this.mapStyle = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
        }

        connectedCallback() {
            this.defineElements();
            this.addListeners()
            this.initSlider();
        }

        defineElements() {
            this.swiperEl = this.querySelector('[data-js-slider]');
            this.mapEl = this.querySelector('[data-js-map]');
            this.locations = JSON.parse(this.querySelector('[data-js-locations]').innerHTML);
            this.settings = JSON.parse(this.querySelector('[data-js-section-settings]').innerHTML);

            console.log(this.settings)
        }

        addListeners() {
            this.customDelegate(
                "click",
                '[data-js-open-map]',
                this.initMap.bind(this)
            )

            this.customDelegate(
                "click",
                '[data-js-close-map]',
                this.close.bind(this)
            )
        }

       async initMap() {
            if (this.mapLoaded) {
                this.openPopup();
                return null;
            }
            this.loadMap().then(() => {
                this.mapLoaded = true;
                this.setMarkers();
                this.openPopup();

            })
        }

        async loadMap() {
            let map;

            const { Map } = await google.maps.importLibrary("maps");


            console.log(this.settings)
            map = new Map( this.mapEl, {
                mapId: this.settings.map_id,
                center: { lat: parseFloat(this.settings.map_lat), lng:parseFloat(this.settings.map_lng) },
                zoom: this.settings.zoom,
                disableDefaultUI: true,
                scaleControl: true
            });

            this.map = map;


        }

        openPopup() {
            this._isOpened ? this.close() : this.open();
        }


        async setMarkers() {

            const {AdvancedMarkerElement} = await google.maps.importLibrary("marker");


            this.locations.forEach( location => {

                const marker = new AdvancedMarkerElement({
                    map: this.map,
                    title: location.club_name,
                    content: this.buildContent(location),
                    position: {
                        lat: parseFloat(location.club_map_latitude),
                        lng: parseFloat(location.club_map_longitude)
                    },
                });


                marker.addListener("click", () => {
                    this.toggleHighlight(marker, location);
                });


            });
        }

        toggleHighlight(markerView, location) {
            if (markerView.content.classList.contains("highlight")) {
                markerView.content.classList.remove("highlight");
                markerView.zIndex = null;
            } else {
                markerView.content.classList.add("highlight");
                markerView.zIndex = 1;
            }
        }

       buildContent(location) {

            const content = document.createElement("div");
            content.classList.add("community__map-location");
            content.innerHTML = `
             <div class="community__map-location-icon">
                      <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="21.5" cy="21.5" r="21.5" fill="black"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0963 25.712C17.1539 25.712 13.1475 21.7421 13.1475 16.8446V7.97726H22.0963C27.0388 7.97726 31.0452 11.9472 31.0452 16.8446C31.0452 21.7421 27.0388 25.712 22.0963 25.712ZM17.6219 35.0227C20.0927 35.0227 22.0963 33.0373 22.0963 30.589V26.1554H17.6219C15.1511 26.1554 13.1475 28.1408 13.1475 30.589C13.1475 33.0373 15.1511 35.0227 17.6219 35.0227Z" fill="white"/>
                        </svg> 
             </div>
             <a href="${location.club_page}" class="community__map-location-wrap">
            
                <span class="community__map-location-img">
                   <img src="${location.club_photo}" />
                 </span>
                <span class="community__map-location-content">
                 <span class="community__map-location-title"> 
                   ${location.club_name}
                 </span>
                 <span class="community__map-location-address">
                 ${location.club_address}
                </span>
               </span>
               <span class="community__map-location-i-arrow">
               
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 16L14 12L10 8" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>

                </span>
             </a> 
            </div>
             `;
            return content;
        }


        initSlider() {
            if (!this.swiperEl || !window.Swiper) {
                return null;
            }

            this.sliderOptions = {
                slidesPerView: 1.12,
                breakpoints: {
                    768: {
                        slidesPerView: 2.1
                    },
                    1920: {
                        slidesPerView: 3.1
                    }
                }
            };

            this.slider = new window.Swiper(this.swiperEl, this.sliderOptions);
        }

        togglePopup(show) {
            show = (show !== undefined) ? show : !this._isOpened;
            this._isOpened = show;
            this._isOpened ? this.setAttribute('open','') : this.removeAttribute('open');
            this._isOpened ? document.body.classList.add('overflow_block') : document.body.classList.remove('overflow_block');
        };

        close() {
            this.togglePopup(false);
        };

        open() {
            this.togglePopup(true);
        }

        customDelegate(eventName, elementSelector, handler) {
            this.addEventListener(eventName, (e) => {
                const element = e.target.closest(elementSelector);

                if (element) {
                    handler.call(element, e, element);
                }
            }, false);
        };


    }

    customElements.define('section-community-clubs-with-map', SectionCommunityClubsWithMap);
}

